<template>
  <div class="HistoryButtons">
    <UiIcon
      :title="$t('HistoryButtons.Undo')"
      @click="editor.chain().focus().undo().run()"
      class="ToolbarButton"
      value="mdi:undo"
      :class="{'UiIcon--disabled': !editor.can().undo()}"
    />

    <UiIcon
      :title="$t('HistoryButtons.Redo')"
      @click="editor.chain().focus().redo().run()"
      class="ToolbarButton"
      value="mdi:redo"
      :class="{'UiIcon--disabled': !editor.can().redo()}"
    />
  </div>
</template>

<script>
import useI18n from '@/modules/i18n/mixins/useI18n.js';
import { UiIcon } from '@/modules/ui/components';

export default {
  mixins: [useI18n],
  components: { UiIcon },
  props: {
    editor: {
      type: Object,
      required: true,
    },
  },

  i18n: {
    en: {
      'HistoryButtons.Undo': 'Undo',
      'HistoryButtons.Redo': 'Redo',
    },
    es: {
      'HistoryButtons.Undo': 'Deshacer',
      'HistoryButtons.Redo': 'Rehacer',
    },
    de: {
      'HistoryButtons.Undo': 'Rückgängig machen',
      'HistoryButtons.Redo': 'Redo',
    },
    fr: {
      'HistoryButtons.Undo': 'Annuler',
      'HistoryButtons.Redo': 'Redo',
    },
    it: {
      'HistoryButtons.Undo': 'Annullamento',
      'HistoryButtons.Redo': 'Redo',
    },
    pt: {
      'HistoryButtons.Undo': 'Desfazer',
      'HistoryButtons.Redo': 'Refazer',
    },
  },
};
</script>

<style lang="scss">
.HistoryButtons {
  .UiIcon--disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>